import { render } from "./field-file.vue?vue&type=template&id=a8a2c15c"
import script from "./field-file.vue?vue&type=script&lang=js"
export * from "./field-file.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__